package com.solevo.dist.network.firebase.api.transactions

import com.solevo.dist.application.models.Transaction
import com.solevo.dist.application.models.User.Companion.currentCustomerId
import com.solevo.dist.application.models.User.Companion.legalId
import com.solevo.dist.network.api.transactions.TransactionRemoteSource
import com.solevo.dist.network.firebase.api.transactions.models.FirebaseTransaction
import com.solevo.dist.network.firebase.api.transactions.models.toTransaction
import com.solevo.dist.network.implementation.firebase.FirebaseFields
import com.solevo.dist.network.implementation.firebase.FirestoreCollections
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class TransactionFirestoreRemoteSource : TransactionRemoteSource {

    private val firestore = Firebase.firestore

    override fun getTransactionsLive(): Flow<List<Transaction>> {
        return firestore.collection(FirestoreCollections.TRANSACTIONS_COLLECTION)
            .where { FirebaseFields.CUSTOMER_ID equalTo currentCustomerId.value }
            .where { FirebaseFields.LEGAL_ENTITY_ID equalTo legalId }
            .snapshots
            .map { snap -> snap.documents.mapNotNull { it.data<FirebaseTransaction?>()?.toTransaction() } }
    }

    override fun getTransaction(id: String): Flow<Transaction?> {
        return firestore.collection(FirestoreCollections.TRANSACTIONS_COLLECTION)
            .where { FirebaseFields.TRANSACTION_ID equalTo id }
            .where { FirebaseFields.LEGAL_ENTITY_ID equalTo legalId }
            .snapshots
            .map { q -> q.documents.firstOrNull()?.data<FirebaseTransaction?>()?.toTransaction() }
    }

    override fun getTransactionByInvoiceIdLive(invoiceId: String): Flow<Transaction> {
        return firestore.collection(FirestoreCollections.TRANSACTIONS_COLLECTION)
            .where { FirebaseFields.INVOICE_ID equalTo invoiceId }
            .where { FirebaseFields.LEGAL_ENTITY_ID equalTo legalId }
            .snapshots
            .map { q -> q.documents.first().data<FirebaseTransaction?>()!!.toTransaction() }
    }
}


